import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import Button from "@mui/material/Button";
import { useState } from "react";

const TableToolbar = ({ searchValue, onChange, onShowAll }) => {
	const [buttonText, setButtonText] = useState("Show All");
	return (
		<Box
			sx={{
				p: 0.5,
				pb: 0,
			}}
			display="flex"
			justifyContent="space-between"
		>
			<TextField
				variant="standard"
				value={searchValue}
				onChange={(event) => onChange("search", event.target.value)}
				placeholder="Search…"
				InputProps={{
					startAdornment: <SearchIcon fontSize="small" />,
					endAdornment: (
						<IconButton
							title="Clear"
							aria-label="Clear"
							size="small"
							style={{ visibility: searchValue ? "visible" : "hidden" }}
							onClick={() => onChange("search", "")}
						>
							<ClearIcon fontSize="small" />
						</IconButton>
					),
				}}
				sx={{
					width: {
						xs: 1,
						sm: "auto",
					},
					m: (theme) => theme.spacing(1, 0.5, 1.5),
					"& .MuiSvgIcon-root": {
						mr: 0.5,
					},
					"& .MuiInput-underline:before": {
						borderBottom: 1,
						borderColor: "divider",
					},
				}}
			/>
			{onShowAll ? (
				<Button
					variant="contained"
					sx={{ height: 40, marginRight: 1, marginTop: 1 }}
					onClick={() => {
						if (buttonText === "Show All") {
							setButtonText("Show Suggestions");
						} else {
							setButtonText("Show All");
						}
						onShowAll();
					}}
				>
					{buttonText}
				</Button>
			) : null}
		</Box>
	);
};

export default TableToolbar;
